'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import I18n from 'I18n';
import { SCHEDULE_FREQUENCY, DAYS, MONTH_DAYS, LAST_DAY_OF_MONTH } from '../../../lib/schedulingLogic';
import { getEventValue } from '../../../utils/jsEventUtils';
import { useControlsContext } from '../context';
import { jsx as _jsx } from "react/jsx-runtime";
const scheduleOnDayOptions = [{
  value: DAYS.MONDAY,
  text: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.weekDays.monday"
  })
}, {
  value: DAYS.TUESDAY,
  text: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.weekDays.tuesday"
  })
}, {
  value: DAYS.WEDNESDAY,
  text: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.weekDays.wednesday"
  })
}, {
  value: DAYS.THURSDAY,
  text: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.weekDays.thursday"
  })
}, {
  value: DAYS.FRIDAY,
  text: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.weekDays.friday"
  })
}, {
  value: DAYS.SATURDAY,
  text: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.weekDays.saturday"
  })
}, {
  value: DAYS.SUNDAY,
  text: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.weekDays.sunday"
  })
}];
const ShareScheduleDayPickerSelect = () => {
  const {
    shareScheduleOnDays,
    setShareScheduleOnDay,
    shareScheduleFrequency
  } = useControlsContext();
  const getDeliveryLabel = () => shareScheduleFrequency === SCHEDULE_FREQUENCY.WEEKLY ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.dayOfWeek"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.dayOfMonth"
  });
  const getScheduleOnMonthlyAllDayOptions = () => {
    const monthDays = Object.values(MONTH_DAYS).map(value => {
      return {
        text: `${value}`,
        value
      };
    });
    monthDays.push({
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.monthDays.lastDayOfMonth"
      }),
      value: LAST_DAY_OF_MONTH
    });
    return monthDays;
  };
  const getDayPickerOptions = () => {
    if (shareScheduleFrequency === SCHEDULE_FREQUENCY.WEEKLY) {
      return scheduleOnDayOptions;
    }
    return getScheduleOnMonthlyAllDayOptions();
  };
  return /*#__PURE__*/_jsx(FormControl, {
    label: getDeliveryLabel(),
    required: true,
    children: /*#__PURE__*/_jsx(Select, {
      marginInlineEnd: "200",
      onChange: e => {
        const value = getEventValue(e);
        value.sort((a, b) => a - b);
        setShareScheduleOnDay(value);
      },
      value: shareScheduleOnDays,
      options: getDayPickerOptions(),
      multi: true,
      anchorType: 'button',
      placeholder: I18n.text('reporting-action-components.actions.emailReport.dialog.form.emailFormSection.dayPickerPlaceholder')
    })
  });
};
export default ShareScheduleDayPickerSelect;